import { post } from "../utils/backend";
import { SignatureAudit, SignatureAuditRequest } from "../models/SignatureAudit";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/SignatureAuditMock";

const getAllCandidates = async (): Promise<SignatureAudit[]> => {
    if (mock) {
        return getMockData("signature_audit_candidates");
    }
    const resultOrErrorCode = await post<null, SignatureAudit[]>("/audit/signature/getAllCandidates", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getAllProcessed = async (): Promise<SignatureAudit[]> => {
    if (mock) {
        return getMockData("signature_audit_processed");
    }
    const resultOrErrorCode = await post<null, SignatureAudit[]>("/audit/signature/getAllProcessed", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const audit = async (params: SignatureAuditRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<SignatureAuditRequest, boolean>("/audit/signature/audit", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const signatureAuditApi = {
    getAllCandidates,
    getAllProcessed,
    audit
};

